<script>
  import TimesheetCards from "./TimesheetCard.svelte";
  import Spinner from "../Spinner.svelte";
  export let data;
  export let staff;
  export let newdate;
  let timesheet = data.Result;
  let timesheetId = data.Result.TimesheetId;
  let monday = data.Result.Monday.TimeCards;
  let tuesday = data.Result.Tuesday.TimeCards;
  let wednesday = data.Result.Wednesday.TimeCards;
  let thursday = data.Result.Thursday.TimeCards;
  let friday = data.Result.Friday.TimeCards;
  let saturday = data.Result.Saturday.TimeCards;
  let sunday = data.Result.Sunday.TimeCards;
  // days total hours variable //
  let monday_totalhours = timesheet.Monday.DayTotalWork;
  let tuesday_totalhours = timesheet.Tuesday.DayTotalWork;
  let wednesday_totalhours = timesheet.Wednesday.DayTotalWork;
  let thursday_totalhours = timesheet.Thursday.DayTotalWork;
  let saturday_totalhours = timesheet.Saturday.DayTotalWork;
  let sunday_totalhours = timesheet.Sunday.DayTotalWork;
  let friday_totalhours = timesheet.Friday.DayTotalWork;

  // days date variable//
  let monday_date = timesheet.Monday.Date;
  let tuesday_date = timesheet.Tuesday.Date;
  let wednesday_date = timesheet.Wednesday.Date;
  let thursday_date = timesheet.Thursday.Date;
  let friday_date = timesheet.Friday.Date;
  let saturday_date = timesheet.Saturday.Date;
  let sunday_date = timesheet.Sunday.Date;
  let mondayshow = true;
  let tuesdayshow = false;
  let wednesdayshow = false;
  let thursdayshow = false;
  let fridayshow = false;
  let saturdayshow = false;
  let sundayshow = false;

  function showMonday() {
    mondayshow = true;
    tuesdayshow = false;
    wednesdayshow = false;
    fridayshow = false;
    saturdayshow = false;
    sundayshow = false;
    thursdayshow = false;
  }
  function showTuesday() {
    tuesdayshow = true;
    mondayshow = false;
    wednesdayshow = false;
    thursdayshow = false;
    fridayshow = false;
    saturdayshow = false;
    sundayshow = false;
  }
  function showWednesday() {
    wednesdayshow = true;
    mondayshow = false;
    tuesdayshow = false;
    thursdayshow = false;
    fridayshow = false;
    saturdayshow = false;
    sundayshow = false;
  }
  function showThursday() {
    thursdayshow = true;
    mondayshow = false;
    tuesdayshow = false;
    wednesdayshow = false;
    fridayshow = false;
    saturdayshow = false;
    sundayshow = false;
  }
  function showFriday() {
    fridayshow = true;
    mondayshow = false;
    tuesdayshow = false;
    wednesdayshow = false;
    thursdayshow = false;
    saturdayshow = false;
    sundayshow = false;
  }
  function showSaturday() {
    saturdayshow = true;
    mondayshow = false;
    tuesdayshow = false;
    wednesdayshow = false;
    thursdayshow = false;
    fridayshow = false;
    sundayshow = false;
  }
  function showSunday() {
    sundayshow = true;
    mondayshow = false;
    tuesdayshow = false;
    wednesdayshow = false;
    thursdayshow = false;
    fridayshow = false;
    saturdayshow = false;
  }
  let collapse = false;
  let showDetails = localStorage.getItem("collapse");

  function toggleTabCollapse() {
    collapse = !collapse;
    localStorage.setItem("collapse", collapse);
    showDetails = collapse;
    if (collapse) {
      toggleTabShowDetails(showDetails);
    } else {
      localStorage.removeItem("opened-cards");
    }
  }

  function toggleTabShowDetails(res) {
    var openedCards = [];
    setTimeout(function() {
      jQuery(".card-container .content").each(function(ind, val) {
        if (
          jQuery(val)
            .parent()
            .html()
            .indexOf("content") > -1
        ) {
          openedCards.push({
            id: jQuery(val)
              .parent()
              .find(".card-title")
              .data("activityid"),
            status: res
          });
        }
      });
      localStorage.setItem("opened-cards", JSON.stringify(openedCards));
    }, 100);
  }
</script>

<style>
  .tab-container {
    margin: 0 auto;
    width: 100%;
    display: none;
  }
  .tab {
    display: flex;
    overflow-x: scroll;
    padding: 10px 5px;
  }
  .tab-content-container {
    padding: 10px;
  }
  .tablinks {
    background-color: #f1f2f6;
    width: 100%;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 10px 12px;
    transition: 0.3s;
    font-size: 17px;
    border: 1px grey solid;
    border-radius: 10px;
  }

  .tab-button-container {
    width: 100%;
    margin: 0px 5px;
  }

  /* Change background color of buttons on hover */
  .tab button:hover {
    background-color: #ddd;
  }

  .tab button:focus {
    background-color: #3498db;
    color: white;
    border: 1px white solid;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  /* Create an active/current tablink class */
  .tab button:active {
    background-color: #ccc;
  }

  .empty-timesheet-message {
    text-align: center;
    padding: 10px;
    background-color: #f1f2f6;
    border: 30px;
    margin-top: 15px;
    margin-bottom: 30px;
  }
  .active-button {
    background-color: #3498db;
    width: 100%;
    color: white;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 10px 12px;
    transition: 0.3s;
    font-size: 17px;
    border: 1px white solid;
    border-radius: 10px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  /* Style the tab content */

  @media (max-width: 768px) {
    .tab-container {
      display: block;
    }
    .tab {
      background-color: #f1f2f6;
    }
    .active-button {
      background-color: #3498db;
    }
  }
  @media (max-width: 425px) {
    .tab button {
      width: 100px;
    }
    .active-button {
      width: 100px !important;
      background-color: #3498db;
    }
  }
  hr {
    margin: 0;
    border: 1px solid;
  }
</style>

<input
  type="text"
  hidden
  id="tabcollapse"
  value=""
  on:click={toggleTabCollapse} />
<div class="tab-container">
  <div class="tab">
    <div class="tab-button-container">
      {#if mondayshow}
        <button class="active-button" on:click={showMonday}>
          <div class="day-title">
            Mon
            <br />
            {#if monday_date === null}
              Empty date
            {:else}
              {monday_date.substring(5, 7)}/{monday_date.substring(8, 10)}
            {/if}
          </div>
          <hr />
          <div class="day-hours">{monday_totalhours}h</div>
        </button>
      {:else}
        <button class="tablinks" on:click={showMonday}>
          <div class="day-title">
            Mon
            <br />
            {#if monday_date === null}
              Empty date
            {:else}
              {monday_date.substring(5, 7)}/{monday_date.substring(8, 10)}
            {/if}
          </div>
          <hr />
          <div class="day-hours">{monday_totalhours}h</div>
        </button>
      {/if}
    </div>
    <div class="tab-button-container">
      <button class="tablinks" on:click={showTuesday}>
        <div class="day-title">
          Tue
          <br />
          {#if tuesday_date === null}
            Empty date
          {:else}
            {tuesday_date.substring(5, 7)}/{tuesday_date.substring(8, 10)}
          {/if}
        </div>
        <hr />
        <div class="day-hours">{tuesday_totalhours}h</div>
      </button>
    </div>
    <div class="tab-button-container">
      <button class="tablinks" on:click={showWednesday}>
        <div class="day-title">
          Wed
          <br />
          {#if wednesday_date === null}
            Empty date
          {:else}
            {wednesday_date.substring(5, 7)}/{wednesday_date.substring(8, 10)}
          {/if}
        </div>
        <hr />
        <div class="day-hours">{wednesday_totalhours}h</div>
      </button>
    </div>
    <div class="tab-button-container">
      <button class="tablinks" on:click={showThursday}>
        <div class="day-title">
          Thu
          <br />
          {#if thursday_date === null}
            Empty date
          {:else}
            {thursday_date.substring(5, 7)}/{thursday_date.substring(8, 10)}
          {/if}
        </div>
        <hr />
        <div class="day-hours">{thursday_totalhours}h</div>
      </button>
    </div>
    <div class="tab-button-container">
      <button class="tablinks" on:click={showFriday}>
        <div class="day-title">
          Fri
          <br />
          {#if friday_date === null}
            Empty date
          {:else}
            {friday_date.substring(5, 7)}/{friday_date.substring(8, 10)}
          {/if}
        </div>
        <hr />
        <div class="day-hours">{friday_totalhours}h</div>
      </button>
    </div>
    <div class="tab-button-container">
      <button class="tablinks" on:click={showSaturday}>
        <div class="day-title">
          Sat
          <br />
          {#if saturday_date === null}
            Empty date
          {:else}
            {saturday_date.substring(5, 7)}/{saturday_date.substring(8, 10)}
          {/if}
        </div>
        <hr />
        <div class="day-hours">{saturday_totalhours}h</div>
      </button>
    </div>
    <div class="tab-button-container">
      <button class="tablinks" on:click={showSunday}>
        <div class="day-title">
          Sun
          <br />
          {#if sunday_date === null}
            Empty date
          {:else}
            {sunday_date.substring(5, 7)}/{sunday_date.substring(8, 10)}
          {/if}
        </div>
        <hr />
        <div class="day-hours">{sunday_totalhours}h</div>
      </button>
    </div>
  </div>
  <div class="tab-content-container">
    <center>
      {#if mondayshow === true}
        {#if monday.length !== 0}
          <div class="cards-container">
            {#each monday as timesheet}
              <TimesheetCards
                title={timesheet.Notes}
                timesheetId={timesheetId}
                job={timesheet.New_JobName}
                deliverable={timesheet.New_DeliverableName}
                task={timesheet.New_Costcentrename}
                taskid={timesheet.New_CostcentreId}
                totalhours={timesheet.New_Actualworkhrs}
                id={timesheet.New_DeliverableId}
                day={'Monday'}
                {newdate}
                jobid={timesheet.New_JobId}
                completed={timesheet.New_IsCompleted}
                {staff}
                activityid={timesheet.ActivityId}
                actualstart={timesheet.ActualStart}
                status={data.Result.Status}
                {showDetails} />
            {/each}
          </div>
        {:else}
          <div class="empty-timesheet-message">No data available</div>
        {/if}
      {/if}

      {#if tuesdayshow === true}
        {#if tuesday.length !== 0}
          <div class="cards-container">
            {#each tuesday as timesheet}
              <TimesheetCards
                title={timesheet.Notes}
                timesheetId={timesheetId}
                job={timesheet.New_JobName}
                deliverable={timesheet.New_DeliverableName}
                task={timesheet.New_Costcentrename}
                taskid={timesheet.New_CostcentreId}
                totalhours={timesheet.New_Actualworkhrs}
                id={timesheet.New_DeliverableId}
                day={'Tuesday'}
                {newdate}
                jobid={timesheet.New_JobId}
                completed={timesheet.New_IsCompleted}
                {staff}
                activityid={timesheet.ActivityId}
                actualstart={timesheet.ActualStart}
                status={data.Result.Status}
                {showDetails} />
            {/each}
          </div>
        {:else}
          <div class="empty-timesheet-message">No data available</div>
        {/if}
      {/if}

      {#if wednesdayshow === true}
        {#if wednesday.length !== 0}
          <div class="cards-container">
            {#each wednesday as timesheet}
              <TimesheetCards
                title={timesheet.Notes}
                timesheetId={timesheetId}
                job={timesheet.New_JobName}
                deliverable={timesheet.New_DeliverableName}
                task={timesheet.New_Costcentrename}
                taskid={timesheet.New_CostcentreId}
                totalhours={timesheet.New_Actualworkhrs}
                id={timesheet.New_DeliverableId}
                day={'Wednesday'}
                {newdate}
                jobid={timesheet.New_JobId}
                completed={timesheet.New_IsCompleted}
                {staff}
                activityid={timesheet.ActivityId}
                actualstart={timesheet.ActualStart}
                status={data.Result.Status}
                {showDetails} />
            {/each}
          </div>
        {:else}
          <div class="empty-timesheet-message">No data available</div>
        {/if}
      {/if}

      {#if thursdayshow === true}
        {#if thursday.length !== 0}
          <div class="cards-container">
            {#each thursday as timesheet}
              <TimesheetCards
                title={timesheet.Notes}
                timesheetId={timesheetId}
                job={timesheet.New_JobName}
                deliverable={timesheet.New_DeliverableName}
                task={timesheet.New_Costcentrename}
                taskid={timesheet.New_CostcentreId}
                totalhours={timesheet.New_Actualworkhrs}
                id={timesheet.New_DeliverableId}
                {newdate}
                day={'Thursday'}
                jobid={timesheet.New_JobId}
                completed={timesheet.New_IsCompleted}
                {staff}
                activityid={timesheet.ActivityId}
                actualstart={timesheet.ActualStart}
                status={data.Result.Status}
                {showDetails} />
            {/each}
          </div>
        {:else}
          <div class="empty-timesheet-message">No data available</div>
        {/if}
      {/if}

      {#if fridayshow === true}
        {#if friday.length !== 0}
          <div class="cards-container">
            {#each friday as timesheet}
              <TimesheetCards
                title={timesheet.Notes}
                timesheetId={timesheetId}
                job={timesheet.New_JobName}
                deliverable={timesheet.New_DeliverableName}
                task={timesheet.New_Costcentrename}
                taskid={timesheet.New_CostcentreId}
                totalhours={timesheet.New_Actualworkhrs}
                id={timesheet.New_DeliverableId}
                day={'Friday'}
                {newdate}
                jobid={timesheet.New_JobId}
                completed={timesheet.New_IsCompleted}
                {staff}
                activityid={timesheet.ActivityId}
                actualstart={timesheet.ActualStart}
                status={data.Result.Status}
                {showDetails} />
            {/each}
          </div>
        {:else}
          <div class="empty-timesheet-message">No data available</div>
        {/if}
      {/if}

      {#if saturdayshow === true}
        {#if saturday.length !== 0}
          <div class="cards-container">
            {#each saturday as timesheet}
              <TimesheetCards
                title={timesheet.Notes}
                timesheetId={timesheetId}
                job={timesheet.New_JobName}
                deliverable={timesheet.New_DeliverableName}
                task={timesheet.New_Costcentrename}
                taskid={timesheet.New_CostcentreId}
                totalhours={timesheet.New_Actualworkhrs}
                id={timesheet.New_DeliverableId}
                day={'Saturday'}
                {newdate}
                jobid={timesheet.New_JobId}
                completed={timesheet.New_IsCompleted}
                {staff}
                activityid={timesheet.ActivityId}
                actualstart={timesheet.ActualStart}
                status={data.Result.Status}
                {showDetails} />
            {/each}
          </div>
        {:else}
          <div class="empty-timesheet-message">No data available</div>
        {/if}
      {/if}

      {#if sundayshow === true}
        {#if sunday.length !== 0}
          <div class="cards-container">
            {#each sunday as timesheet}
              <TimesheetCards
                title={timesheet.Notes}
                timesheetId={timesheetId}
                job={timesheet.New_JobName}
                deliverable={timesheet.New_DeliverableName}
                task={timesheet.New_Costcentrename}
                taskid={timesheet.New_CostcentreId}
                totalhours={timesheet.New_Actualworkhrs}
                id={timesheet.New_DeliverableId}
                day={'Sunday'}
                {newdate}
                jobid={timesheet.New_JobId}
                completed={timesheet.New_IsCompleted}
                {staff}
                activityid={timesheet.ActivityId}
                actualstart={timesheet.ActualStart}
                status={data.Result.Status}
                {showDetails} />
            {/each}
          </div>
        {:else}
          <div class="empty-timesheet-message">No data available</div>
        {/if}
      {/if}
    </center>
  </div>
</div>
